// extracted by mini-css-extract-plugin
module.exports = {"modal":"NounModal_modal__24Xjq","displayNounFooter":"NounModal_displayNounFooter__9N9FF","nounImg":"NounModal_nounImg__1_lzZ","nounWrapper":"NounModal_nounWrapper__14FkD"};